import { useAuth } from "../../context/auth-context";
import type {
  AdminGiftcardTransactionsDataEnvelope,
  AdminGiftcardTransactionsDataPayload,
} from "./adminTransactionsData";
import { apiQueryKey } from "./queryKeys";
import { useApiQuery } from "./useApiQuery";

const DEFAULT_LIMIT = 25;

export type UseAdminGiftcardTransactionsDataParams = {
  page: number;
  search?: string;
  startDate?: string;
  endDate?: string;
  limit?: number;
  enabled?: boolean;
};

/**
 * Paginated gift card trade rows from GET api/admin/transactions/data (type=giftcard).
 */
export function useAdminGiftcardTransactionsDataQuery(
  params: UseAdminGiftcardTransactionsDataParams
) {
  const { isAuthenticated } = useAuth();
  const {
    page,
    search,
    startDate,
    endDate,
    limit = DEFAULT_LIMIT,
    enabled: enabledParam = true,
  } = params;

  return useApiQuery<
    AdminGiftcardTransactionsDataEnvelope,
    AdminGiftcardTransactionsDataPayload
  >({
    queryKey: apiQueryKey("admin-transactions-data", {
      type: "giftcard",
      page,
      limit,
      search: search?.trim() || null,
      startDate: startDate ?? null,
      endDate: endDate ?? null,
    }),
    url: "api/admin/transactions/data",
    params: {
      type: "giftcard",
      page,
      limit,
      search: search?.trim() || undefined,
      startDate,
      endDate,
    },
    enabled: Boolean(isAuthenticated) && enabledParam,
    select: (body) => body.data,
  });
}
